import { ArrowRight } from "lucide-react";
import { getToken } from "@/lib/api";
import AudioNote from "./AudioNote";

const key = () => `mapa_seen_${(getToken() || "").slice(0, 16)}`;
const read = () => JSON.parse(localStorage.getItem(key()) || "[]");
export const seen = {
  has: (id) => read().includes(id),
  add: (id) => localStorage.setItem(key(), JSON.stringify([...new Set([...read(), id])])),
};

// Tela curta de apresentação (abertura, boas-vindas, transições e encerramento).
export default function Interlude({ id, eyebrow, title, body, audio, cta, onNext, children }) {
  return (
    <section className="mx-auto max-w-xl px-5 pb-20 pt-8 fade-up" data-testid={`interlude-${id}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1 className="mt-4 text-3xl leading-tight text-stone-900 sm:text-4xl" data-testid={`interlude-${id}-title`}>{title}</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-stone-700 sm:text-lg">
        {body.map((p) => <p key={p}>{p}</p>)}
      </div>
      {audio && <AudioNote id={id} {...audio} />}
      {children}
      {cta && (
        <button type="button" className="btn-primary mt-8 w-full sm:w-auto" onClick={onNext} data-testid={`interlude-${id}-button`}>
          {cta} <ArrowRight size={18} />
        </button>
      )}
    </section>
  );
}
